import React, { useEffect } from 'react';
import cl from './Home.module.css';
import Product from '../Products/Product/Product';
import { animateScroll as scroll } from 'react-scroll';

const Home = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  let featuredProducts = (p) => {
    if (props.productsData.indexOf(p) < 6) {
      return (
        <Product
          key={p.path}
          onAdd={props.onAdd}
          productId={p.productId}
          name={p.name}
          images={p.images}
          oldPrice={p.oldPrice}
          currency={p.currency}
          discount={p.discount}
          path={'products/' + p.path}
          cartItems={props.cartItems}
        />
      );
    }
  };

  let productElements = props.productsData.map((p) => featuredProducts(p));

  return (
    <section className={cl.app_about}>
      <div style={{ paddingTop: '100px', textAlign: 'center' }}>
        <h1 className={cl.title}>
          Lasciatevi accogliere da {props.aboutData.shopName}!
        </h1>
        <div className={cl.about_products}>{productElements}</div>
        <div className={cl.hour}>
          <p>Orari di Apertura</p>
          <p>Lunedì - Venerdì: 7:00 - 22:00</p>
          <p>Sabato: 8:00 - 22:00</p>
          <p>Domenica: 8:00 - 23:00</p>
        </div>
      </div>
    </section>
  );
};

export default Home;
